export const isAuthenticated = 'isAuthenticated';
export const getShowSidebar = 'getShowSidebar';
export const shouldRefreshApp = 'shouldRefreshApp';
